import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import AuditCategoryCard from './audit-category-card';
import { AUDIT_CATEGORIES } from './constants';
import { AuditCategory } from './types';

const AuditView = () => (
  <Box
    sx={{
      py: { desktop: 4.5, mobile: 6.5 },
      mb: 20,
    }}
  >
    <Typography variant="h2" mb={2}>
      Audit
    </Typography>
    <Typography variant="body" color="text.secondary" sx={{ mb: 3 }}>
      Select a category to audit the information
    </Typography>

    <Grid container spacing={2}>
      {AUDIT_CATEGORIES.map((category: AuditCategory) => (
        <Grid item sm={6} xs={12} key={category.id}>
          <AuditCategoryCard category={category} />
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default AuditView;
